import { z } from 'zod'

// Note: Event workers typically don't need HTTP validation schemas.
// This file is included for consistency and in case the worker
// exposes any API endpoints in the future.

export const entraSyncSchema = z.object({
	name: z.string().min(1),
	description: z.string().optional(),
	isActive: z.boolean().default(true),
})

export type EntraSyncInput = z.infer<typeof entraSyncSchema>
